import { useQuery } from "@tanstack/react-query";
import { ApiError } from "pages/admin-app/shared/models/response/api-errors";
import { ORDER_BY, PER_PAGE } from "pages/admin-app/adminapp.constants";
import { GetEndUsersResponse } from "../models/response/get-end-users-response";
import { getEndUsers } from "../services/end-user-service";

interface Props {
  currentPage: number;
  sortBy?: string;
  orderBy?: ORDER_BY;
  filters?: { [key: string]: string };
  searchQuery?: string;
}

export function useEndUsers({
  currentPage,
  sortBy,
  orderBy,
  filters,
  searchQuery,
}: Props) {
  const { data, error, isLoading, isError, refetch } = useQuery<
    GetEndUsersResponse,
    ApiError
  >({
    queryKey: ["endUsers", currentPage, sortBy, orderBy, filters, searchQuery],
    queryFn: () =>
      getEndUsers({
        page: currentPage,
        perPage: PER_PAGE,
        sortBy,
        orderBy,
        filters,
        searchQuery,
      }),
  });

  const baseErrorResponse = error ? error.message : null;

  return {
    data,
    error: baseErrorResponse,
    isLoading,
    isError,
    refetch,
  };
}
